import {differenceInCalendarDays} from "date-fns";

export const ValidateEventFilter = (filter) => {

    if (typeof(filter.DateFrom) != 'undefined' && typeof(filter.DateTo) != 'undefined') {
        const days = differenceInCalendarDays(Date.parse(filter.DateTo), Date.parse(filter.DateFrom));

        const allowedKeys = ["sort", "page", "itemsOnPage", "DateFrom", "DateTo"]
        const allKeys = Object.keys(filter);

        const actualFilters = allKeys.filter(x => !allowedKeys.includes(x)).filter(x => filter[x]);

        if (days > 1 && actualFilters.length == 0) {
            return false;
        }
    }

    return true;
}